
import Select from '@/ui-kit/components/select';
import MultiSelect from '@/ui-kit/components/multi-select';
import { FilterCommonEventType } from '../enums';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import { DEFAULT_BATH_OPTIONS } from '../constants/options';

export default {
  name: 'FilterBaths',
  components: {
    Select,
    MultiSelect,
  },
  props: {
    className: {
      default: '',
      type: String,
    },
    value: {
      required: true,
      type: [Number, Array],
    },
    checkboxIconSize: {
      default: StyleSizeType.XSmall,
      type: String,
    },
    options: {
      default: () => DEFAULT_BATH_OPTIONS,
      type: Array,
    },
    colorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    labelColorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    iconColor: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    isMultiSelect: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    filterComponent() {
      return this.isMultiSelect ? MultiSelect : Select;
    },
  },
  methods: {
    handleChange(value) {
      this.$emit(FilterCommonEventType.Change, value);
    },
  },
};
